export const FirebaseConfig = {
	"projectId": "tylolitepanama",
	"appId": "1:287725357149:web:3d7f139390c6ee763e65b4",
	"databaseURL": "https://tylolitepanama-default-rtdb.firebaseio.com",
	"storageBucket": "tylolitepanama.firebasestorage.app",
	"apiKey": "AIzaSyB21p-Yi1xqviYMoKsUhoBCvcUZPlcKpZs",
	"authDomain": "tylolitepanama.firebaseapp.com",
	"messagingSenderId": "287725357149",
	"measurementId": "G-1MP0TNN5TS",
	"projectNumber": "287725357149",
	"version": "2"
};